export type AdditionConfigFlags = {
  isStripeEnabled: boolean;
  isDS2Enabled: boolean;
};

export const buildAdditionConfig = (
  stripeEnabled: boolean,
  ds2Enabled: boolean
): string => {
  return JSON.stringify({
    additionalConfigs: {
      stripe: { enabled: !!stripeEnabled },
      ds2: { enabled: !!ds2Enabled },
    },
  });
};

export const parseAdditionConfig = (
  additionConfig: string | object | null | undefined
): AdditionConfigFlags => {
  const defaults: AdditionConfigFlags = {
    isStripeEnabled: false,
    isDS2Enabled: false,
  };

  if (!additionConfig) return defaults;

  try {
    const parsed =
      typeof additionConfig === "string"
        ? additionConfig.trim()
          ? JSON.parse(additionConfig)
          : null
        : additionConfig;

    return {
      isStripeEnabled: !!parsed?.additionalConfigs?.stripe?.enabled,
      isDS2Enabled: !!parsed?.additionalConfigs?.ds2?.enabled,
    };
  } catch {
    return defaults;
  }
};
